export default "__VITE_ASSET__Bdl6BahJ__"